import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { TipoCargoService } from '../../../services/TipoCargoService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'cc_tipo',
    label: 'Tipo',
    type: 'text',
    col: 12,
    placeholder: 'Ej. CARGO ADMINISTRATIVO',
    validators: [
      Validators.required("El tipo es obligatorio")
    ],
  },
];

export const TipoCargoForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await TipoCargoService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await TipoCargoService.guardar(values);
  };

  return (
    <CatalogForm
      title="Tipo de Cargo / Crédito"
      subtitle="Clasificación de movimientos y conceptos de cobro o abono"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/TiposCargos"
    />
  );
};

export default TipoCargoForm;
